module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("仓库地址列表")])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 2
    }
  }, [_c('el-button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新建")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.fetchList
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "storageNo",
      "label": "编号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "storageName",
      "label": "仓库名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "recipient",
      "label": "收件人"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "提交时间"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return (_vm.row.created) ? _c('span', [_vm._v(_vm._s(new Date(_vm.row.created).getFullYear() + '-' + (new Date(_vm.row.created).getMonth() + 1) + '-' + new Date(_vm.row.created).getDate() + ' ' + new Date(_vm.row.created).getHours() + ':' + new Date(_vm.row.created).getMinutes() + ':' + new Date(_vm.row.created).getSeconds()) + " ")]) : _vm._e()
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "deviceCount",
      "label": "拥有的设备数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "width": "200",
      "label": "操作"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [_c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleView(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("查看")]), _vm._v(" "), _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleEdit(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("编辑")])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "查看仓库信息",
      "visible": _vm.dialogFormVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "仓库名称：",
      "label-width": "150px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.storageName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "仓库编号：",
      "label-width": "150px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.storageNo))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "收货人：",
      "label-width": "150px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.recipient))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号：",
      "label-width": "150px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.mobile))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "详细地址：",
      "label-width": "150px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.fullAddress))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新建仓库地址",
      "visible": _vm.dialogNewVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogNewVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "newForm",
    attrs: {
      "model": _vm.newForm,
      "rules": _vm.addStorageRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "仓库名称",
      "label-width": "150px",
      "prop": "storageName"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.newForm.storageName),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "storageName", $$v)
      },
      expression: "newForm.storageName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "仓库编号",
      "label-width": "150px",
      "prop": "storageNo"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.newForm.storageNo),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "storageNo", $$v)
      },
      expression: "newForm.storageNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "收货人",
      "label-width": "150px",
      "prop": "recipient"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.newForm.recipient),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "recipient", $$v)
      },
      expression: "newForm.recipient"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号",
      "label-width": "150px",
      "prop": "mobile"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.newForm.mobile),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "mobile", $$v)
      },
      expression: "newForm.mobile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "省市区选择",
      "label-width": "150px"
    }
  }, [_c('el-cascader', {
    attrs: {
      "size": "large",
      "options": _vm.options
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.selectedOptions),
      callback: function($$v) {
        _vm.selectedOptions = $$v
      },
      expression: "selectedOptions"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "详细地址",
      "label-width": "150px",
      "prop": "address"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.newForm.address),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "address", $$v)
      },
      expression: "newForm.address"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogNewVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addNewOne
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑仓库地址",
      "visible": _vm.dialogEditVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogEditVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "newForm",
    attrs: {
      "model": _vm.newForm,
      "rules": _vm.addStorageRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "仓库名称",
      "label-width": "150px",
      "prop": "storageName"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.newForm.storageName),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "storageName", $$v)
      },
      expression: "newForm.storageName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "仓库编号",
      "label-width": "150px",
      "prop": "storageNo"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.newForm.storageNo),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "storageNo", $$v)
      },
      expression: "newForm.storageNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "收货人",
      "label-width": "150px",
      "prop": "recipient"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.newForm.recipient),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "recipient", $$v)
      },
      expression: "newForm.recipient"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号",
      "label-width": "150px",
      "prop": "mobile"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.newForm.mobile),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "mobile", $$v)
      },
      expression: "newForm.mobile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "省市区选择",
      "label-width": "150px"
    }
  }, [_c('el-cascader', {
    attrs: {
      "size": "large",
      "options": _vm.options
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.selectedOptions),
      callback: function($$v) {
        _vm.selectedOptions = $$v
      },
      expression: "selectedOptions"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "详细地址",
      "label-width": "150px",
      "prop": "fullAddress"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.newForm.fullAddress),
      callback: function($$v) {
        _vm.$set(_vm.newForm, "fullAddress", $$v)
      },
      expression: "newForm.fullAddress"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogEditVisible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.editStorage
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24b3417c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/order/StorageList.vue
// module id = 720
// module chunks = 1